import restrictedUsernames from './constants/restrictedUsernames';

export const capitalize = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const isUsernameRestricted = username => {
    return restrictedUsernames.some(restricted => username.toLowerCase() === restricted.toLowerCase() || username.toLowerCase().includes(restricted.toLowerCase()));
}

export const maskEmail = (email) => {
    const [local, domain] = email.split('@');
  
    if (!local || !domain) return '';
  
    const firstChar = local[0];
    const lastChar = local[local.length - 1];
  
    const maskedLocal =
      local.length <= 2
        ? firstChar + '*'
        : firstChar + '*'.repeat(local.length - 2) + lastChar;
  
    return `${maskedLocal}@${domain}`;
  }
  